import React from 'react';

import useThunkReducer from 'common/utils/use-thunk-reducer';
import Reducer from './reducer';

export const Context = React.createContext({
  isDrawing: false,
  hasDrawn: false,
});

export const ContextProvider = (props) => {
  const initialState = React.useContext(Context);
  const [state, dispatch] = useThunkReducer(Reducer, initialState);
  const value = React.useMemo(() => ({ state, dispatch }), [dispatch, state]);

  return (
    <Context.Provider value={value}>
      {props.children}
    </Context.Provider>
  );
};

export const withCanvasContextProvider = (Component) => {
  return (
    // eslint-disable-next-line react/display-name
    React.forwardRef((props, ref) => (
      <ContextProvider>
        <Component {...props} ref={ref} />
      </ContextProvider>
    ))
  );
};

export const withCanvasContext = (Component) => {
  return (
    // eslint-disable-next-line react/display-name
    React.forwardRef((props, ref) => (
      <Context.Consumer>
        {(value) => (
          <Component {...props} canvasContext={value} ref={ref} />
        )}
      </Context.Consumer>
    ))
  );
};
